<template>
	<div class="light">
		<BaseIcon
			icon="icon-idea"
			:color="color"
		/>
	</div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon'

export default {
	name: "Light",
	components: {
		BaseIcon
	},
	props: {
		isLight: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		color() {
			return this.isLight ? '#F1CD19' : '#000'
		}
	}
}
</script>

<style lang="scss" scoped>
.light {
	width: 100%;
	text-align: center;
}
</style>